module.exports = __webpack_public_path__ + "img/video-drams.f3797620.jpg";